/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ControlStage = {
    Triage: 'TRIAGE',
    Hunt: 'HUNT',
    Monitor: 'MONITOR'
} as const;
export type ControlStage = typeof ControlStage[keyof typeof ControlStage];


export function ControlStageFromJSON(json: any): ControlStage {
    return ControlStageFromJSONTyped(json, false);
}

export function ControlStageFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlStage {
    return json as ControlStage;
}

export function ControlStageToJSON(value?: ControlStage | null): any {
    return value as any;
}

